import { render, staticRenderFns } from "./manageVideosModal.html?vue&type=template&id=b6881df0&"
import script from "./manageVideosModal.vue?vue&type=script&lang=js&"
export * from "./manageVideosModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports